export function whatsAppChatUrl(rawPhone) {
  const raw = String(rawPhone || '').trim();
  if (!raw || /[^\d+\s().-]/.test(raw) || (raw.includes('+') && !/^\+[^+]*$/.test(raw))) return '';
  const international = raw.startsWith('+') || raw.startsWith('00');
  let digits = raw.replace(/\D/g, '');
  if (raw.startsWith('00')) digits = digits.slice(2);
  // Local Italian mobile numbers use the same default as the other staff lists.
  if (!international && /^3\d{9}$/.test(digits)) digits = `39${digits}`;
  if (!/^[1-9]\d{6,14}$/.test(digits)) return '';
  return `https://wa.me/${digits}`;
}
